// extracted by mini-css-extract-plugin
export default {"textOverImg":"photoArchive_textOverImg__figE7","object__select":"photoArchive_object__select__H9zAE","download__cont":"photoArchive_download__cont__RGlPJ"};